import { signInGuestUser, setLocation } from "../redux/actions/action-creator";
import {
  DEFAULT_GUEST_LOCATION,
} from "./locationDefaults";

export { DEFAULT_GUEST_LOCATION } from "./locationDefaults";

let guestLoginPromise = null;

export const isSuccessResponse = (response) =>
  response?.result === 1 ||
  response?.result === true ||
  response?.result === "1";

export const getStoredAccessToken = () => {
  if (typeof window === "undefined") {
    return null;
  }

  return localStorage.getItem("access_token");
};

export const getStoredUserRole = () => {
  if (typeof window === "undefined") {
    return null;
  }

  return localStorage.getItem("userRole");
};

export const isGuestUser = (userData = {}) =>
  Boolean(
    userData?.guest ||
      userData?.role_type === "GUEST" ||
      getStoredUserRole() === "GUEST"
  );

export const hasAuthenticatedSession = (userData = {}) =>
  Boolean(userData?.id || getStoredAccessToken());

export const clearGuestSession = () => {
  if (typeof window === "undefined") {
    return;
  }

  localStorage.removeItem("access_token");
  localStorage.removeItem("userRole");
};

export const persistGuestSession = (response) => {
  const accessToken = response?.data?.access_token;

  if (!accessToken || typeof window === "undefined") {
    return false;
  }

  localStorage.setItem("access_token", accessToken);
  localStorage.setItem("userRole", response?.data?.role_type || "GUEST");

  return true;
};

export const performGuestLogin = (dispatch, options = {}) => {
  if (guestLoginPromise) {
    return guestLoginPromise;
  }

  guestLoginPromise = (async () => {
    const locationResult =
      options.locationResult ||
      (options.location
        ? {
            location: options.location,
            permissionDenied: false,
            shouldRedirectToAddressList: false,
          }
        : {
            location: DEFAULT_GUEST_LOCATION,
            permissionDenied: false,
            shouldRedirectToAddressList: false,
          });
    const guestLocation = locationResult.location || DEFAULT_GUEST_LOCATION;
    const response = await dispatch(
      signInGuestUser({ country_id: guestLocation.country_id })
    );

    if (!isSuccessResponse(response) || !persistGuestSession(response)) {
      throw response || new Error("Guest login failed.");
    }

    dispatch(setLocation(guestLocation));

    return {
      response,
      location: guestLocation,
      permissionDenied: locationResult.permissionDenied,
      shouldRedirectToAddressList: locationResult.shouldRedirectToAddressList,
    };
  })();

  guestLoginPromise = guestLoginPromise.finally(() => {
    guestLoginPromise = null;
  });

  return guestLoginPromise;
};
